var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"src":_vm.icon,"alt":_vm.alt,"height":_vm.height},on:{"click":_vm.confirmAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }